/**
 * Leading spaces prepended to each included closing / printed-name line when composing
 * the Fabric/print message. Tunable constant — not a layout measurement.
 */
export const HANDWRITTEN_NOTE_CLOSING_INDENT_SPACES = 8
